import React from 'react';
import { Grid, Box, makeStyles } from '@material-ui/core';

import { AssuranceIcon } from 'images';
import Button from 'components/Button';
import { Captions } from 'components/Typography';
import { uppercase } from 'utils/string';
import { sanlamDarkBlue, sanlamYellow } from 'Material-UI/colors';
import {
  ReversedStyledGrid,
  StyledCard,
  StyledIcon,
  StyledShortBody,
  StyledCaption,
  StyledGrid,
} from 'components/ItemInfoCard/styles';
import { MRHInfoCardProps, styles } from 'components/ItemInfoCard/types';
import { pushTo } from 'helpers/routes';
import StatusChip from 'components/StatusChip';
import MRHContractBackground from 'images/BG-contract-MRH.svg';
import messages from 'components/ItemInfoCard/messages';
import { translate } from 'helpers/intl';
import { injectIntl } from 'react-intl';
import PAGES from 'routes/pages';
import { setMrhDetailsPageBreadcrumbsPath } from 'store/global/actions';
import { useDispatch } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { useSelector } from 'react-redux';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    width: '90px !important',
    borderRadius: '6px',
    color: '#172C51 !important',
    border: '1px solid #FFFFFF !important',
    '&:hover': {
      color: '#285BC7 !important',
    },
  },
});

const MRHInfoCard = (props: MRHInfoCardProps) => {
  const dispatch = useDispatch();
  const {
    dateValue,
    formuleValue,
    title,
    status,
    wrapperPaddingLeft,
    wrapperPaddingRight,
    contractsNumber,
    statusLabel,
  } = props;
  const classes = useStyles();
  const styles: styles = {
    icon: 'MRHMainIcon',
    titleColor: sanlamYellow,
    labelsColor: 'rgba(255,255,255,0.87)',
    valuesColor: '#FFF',
    backgroundImage: MRHContractBackground,
    buttonRootStyles: classes.root,
  };
  const lang = useSelector(getLocaleSelector);
  const reverse = lang === LANGUAGES.AR;
  return (
    <StyledCard
      backgroundImage={styles.backgroundImage}
      backgroundColor={styles.backgroundColor}
      paddingLeft={wrapperPaddingLeft}
      paddingRight={wrapperPaddingRight}
    >
      <StyledGrid
        container
        alignItems="center"
        justify="space-between"
        marginBottom="17px"
      >
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid>
            <ReversedStyledGrid
              reverse={reverse}
              container
              justify="space-between"
            >
              <Grid>
                {styles.icon && (
                  <StyledGrid text-align="center" item xs={1} height="30px">
                    <StyledIcon
                      width="21px"
                      height="20px"
                      src={AssuranceIcon[styles.icon]}
                      alt="item-icon"
                    />
                  </StyledGrid>
                )}
              </Grid>
              <Grid>
                <Box>
                  <StyledShortBody
                    lineHeight="17px"
                    weight="bold"
                    color={styles.titleColor}
                  >
                    {uppercase(title || '')}
                  </StyledShortBody>
                  <StyledCaption
                    weight="400"
                    fontSize={11}
                    color="rgba(255,255,255,0.87)"
                    marginBottom={0}
                  >
                    {contractsNumber}
                  </StyledCaption>
                </Box>
              </Grid>
            </ReversedStyledGrid>
          </Grid>
          <Grid>
            <StyledGrid item xs={3} textAlign="end">
              <StatusChip status={status} label={statusLabel} />
            </StyledGrid>
          </Grid>
        </ReversedStyledGrid>
      </StyledGrid>
      <Grid container justify="space-between">
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <StyledCaption
              color={styles.labelsColor || '#9797AF'}
              marginBottom="6px"
            >
              {uppercase(translate({ ...messages.Formule }, props))}
            </StyledCaption>
          </Grid>
          <Grid item xs={6}>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              marginBottom="6px"
              textAlign="end"
            >
              {formuleValue}
            </StyledCaption>
          </Grid>
        </Grid>
        <Grid container justify="space-between">
          <Grid item xs={6}>
            <Captions color={styles.labelsColor || '#9797AF'}>
              {uppercase(translate({ ...messages.dateEcheance }, props))}
            </Captions>
          </Grid>
          <Grid item xs={6}>
            <StyledCaption
              color={styles.valuesColor || sanlamDarkBlue}
              weight="bold"
              textAlign="end"
              marginBottom="15px"
            >
              {dateValue}
            </StyledCaption>
          </Grid>
        </Grid>
        <ReversedStyledGrid reverse={reverse} container justify="space-between">
          <Grid item xs={4}>
            <GaClickHOC
              category={EVENT_CATEGORIES.MRH_ACCUEIL}
              label="Mes Contrats_Voir details "
            >
              <Button
                variant="outlined"
                className={styles.buttonRootStyles}
                size="small"
                onClick={() => {
                  dispatch(
                    setMrhDetailsPageBreadcrumbsPath([
                      {
                        name: 'habitation',
                        route: PAGES.MRHDASHBOARD,
                      },
                      {
                        name: 'contractEtGarantie',
                      },
                    ]),
                  );
                  pushTo(PAGES.MRH_DETAILS);
                }}
              >
                {translate({ ...messages.voirTous }, props)}
              </Button>
            </GaClickHOC>
          </Grid>
        </ReversedStyledGrid>
      </Grid>
    </StyledCard>
  );
};

export default injectIntl(MRHInfoCard);
